module.exports = __webpack_public_path__ + "static/media/pdf.56ce668e.svg";